// This file is auto-generated by tools/scripts/pieces/update-available-pieces-translate.ts
// Do not edit manually - changes will be overwritten on next tolgee pull
export const AVAILABLE_PIECES_TRANSLATE = [
  'piece-csv',
  'piece-docusign',
  'piece-dropbox',
  'piece-flow-control',
  'piece-forms',
  'piece-geremy',
  'piece-geremy-admin',
  'piece-gmail',
  'piece-google-calendar',
  'piece-google-docs',
  'piece-google-drive',
  'piece-google-sheets',
  'piece-kizeo-forms',
  'piece-klear',
  'piece-microsoft-excel-365',
  'piece-microsoft-onedrive',
  'piece-microsoft-outlook',
  'piece-microsoft-sharepoint',
  'piece-notion',
  'piece-openai',
  'piece-postgres',
  'piece-sage',
  'piece-salesforce',
  'piece-schedule',
  'piece-sftp',
  'piece-slack',
];
